<template>
    <div class="home">
        <nav class="navbar navbar-light" style="background-color: #e3f2fd;">
            <router-link class="navbar-brand" to="/">AQStar</router-link>
            <el-dropdown @command="handleDropDownCommand">
                <span class="el-dropdown-link">
                    {{ username }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="modify_password">修改密码</el-dropdown-item>
                    <el-dropdown-item command="logout">注销</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </nav>
        <el-container>
            <el-container>
                <el-aside v-if="$route.name!=='projectEdit'&&$route.name!=='product'">
                    <el-menu :default-openeds="['1', '2', '3', '4']" :default-active="$route.path" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" :collapse="isCollapse" router>

                        <el-submenu index="1">
                            <template slot="title">
                                <i class="el-icon-user"></i>
                                <span slot="title">用户管理</span>
                            </template>
                            <el-menu-item index="/adminUser">用户列表</el-menu-item>
                        </el-submenu>

                        <el-submenu index="2">
                            <template slot="title">
                                <i class="el-icon-data-analysis"></i>
                                <span slot="title">分析</span>
                            </template>
                            <el-menu-item index="/user/regional">用户</el-menu-item>
                            <el-menu-item index="/device/regional">设备</el-menu-item>
                        </el-submenu>

                        <el-submenu index="3">
                            <template slot="title">
                                <i class="el-icon-date"></i>
                                <span slot="title">日志</span>
                            </template>
                            <el-menu-item index="/httptrace">接口访问日志</el-menu-item>
                        </el-submenu>

                        <el-submenu index="4" v-if="hasPerm('sale_retrieve')">
                            <template slot="title">
                                <i class="el-icon-shopping-bag-1"></i>
                                <span slot="title">销售管理</span>
                            </template>
                            <el-menu-item index="/sale">销售单</el-menu-item>
                            <el-menu-item index="/sale/add" v-if="hasPerm('sale_create')">新增销售单</el-menu-item>
                            <el-menu-item index="/term" v-if="hasPerm('sale_create')">条款</el-menu-item>
                            <el-menu-item index="/term/add" v-if="hasPerm('sale_create')">新增条款</el-menu-item>
                        </el-submenu>
                        
                    </el-menu>
                </el-aside>
                <el-main>
                    <router-view />
                </el-main>
            </el-container>
        </el-container>
        <el-dialog title="修改密码" :visible.sync="dialogFormVisible" width="35%">
            <el-form :model="modifyPwdForm" :rules="modifyPwdRules" ref="modifyPwdForm">
                <el-form-item label="原密码" :label-width="formLabelWidth" prop="oldPwd">
                    <el-input v-model="modifyPwdForm.oldPwd" clearable show-password></el-input>
                    <!-- <div class="el-form-item__error" style="position: relative;">错误信息</div> -->
                </el-form-item>
                <el-form-item label="新密码" :label-width="formLabelWidth" prop="newPwd">
                    <el-input v-model="modifyPwdForm.newPwd" clearable show-password></el-input>
                </el-form-item>
                <el-form-item label="新密码确认" :label-width="formLabelWidth" prop="newPwdConfirm">
                    <el-input v-model="modifyPwdForm.newPwdConfirm" clearable show-password></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitModifyPwdForm('modifyPwdForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 280px;
    min-height: 400px;
}

.el-dropdown-link {
    cursor: pointer;
}
</style>
<script>
// @ is an alias to /src
export default {
    name: 'home',
    data() {
        return {
            isCollapse: false,
            username: this.$store.state.profile.name,
            dialogFormVisible: false,
            formLabelWidth: '100px',
            modifyPwdForm: {
                oldPwd: '',
                newPwd: '',
                newPwdConfirm: ''
            },
            modifyPwdRules: {
                oldPwd: [
                    { required: true, message: '请输入原密码', trigger: 'blur' }
                ],
                newPwd: [
                    { required: true, message: '请输入新密码', trigger: 'change' }
                ],
                newPwdConfirm: [
                    { required: true, message: '请输入新密码确认', trigger: 'change' }
                ]
            }
        };
    },
    methods: {
        navMenuSelectChange(index, indexPath){
            console.log('菜单选中：', index, "----->",indexPath)
        },
        handleOpen(key, keyPath) {
            console.log('打开', key, keyPath);
        },
        handleClose(key, keyPath) {
            console.log('关闭', key, keyPath);
            this.hasPerm('dsfsd')
        },
        handleDropDownCommand(command) {
            switch (command) {
                case 'logout':
                    // statements_1
                    this.logout()
                    break;
                case 'modify_password':
                    this.dialogFormVisible = true
                    this.$nextTick(()=>{
                        this.$refs['modifyPwdForm'].resetFields();
                    })
                    break;
            }
        },
        submitModifyPwdForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$api.api.updatePassword(this.modifyPwdForm).then(
                        resBase => {
                            console.log(resBase)
                            this.$notify({
                                title: '成功',
                                message: '修改密码成功,请重新登录',
                                type: 'success'
                            });
                            this.dialogFormVisible = false
                            this.logout()
                        })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        logout() {
            this.$store.commit("del_profile", null)
            this.$store.commit("del_token", null)
            this.$router.replace({ path: '/login' })
        },
        hasPerm(perm){
            return this.$store.getters.hasPerm(perm)
        }
    },
    components: {}
}
</script>



// WEBPACK FOOTER //
// src/views/Home.vue